export default "__VITE_ASSET__toQx30oa__"